export const DOCUMENTS_PER_PAGE = 5;
